import {selectDomain} from '.';
import {createSelector} from '@reduxjs/toolkit';
import {CostCategory} from 'types/cost-category';

export default (categoryId: CostCategory) =>
  createSelector([selectDomain], state => state.fields[categoryId]);
